const PLAYER_VERSION = '3.3.0'; // SkyPlayer version

const CSS_FILE_NAME = 'SkyPlayer.min.css';
const JS_FILE_NAME = 'SkyPlayer.min.js';

const PLAYER_URL_HOST = (process.env.NODE_ENV || '').trim() === 'production' ? 'player.sky.it' : 'coll.player.sky.it';

export const SKY_PLAYER_CSS = `https://${PLAYER_URL_HOST}/skyplayer/player/v${PLAYER_VERSION}/dist/${CSS_FILE_NAME}`;
export const SKY_PLAYER_JS = `https://${PLAYER_URL_HOST}/skyplayer/player/v${PLAYER_VERSION}/dist/${JS_FILE_NAME}`;

const injectCss = (): Promise<any> => {
  if (document.querySelector(`link[href*="${CSS_FILE_NAME}"]`)) {
    return new Promise((resolve) => resolve(true));
  }
  return new Promise((resolve, reject) => {
    const css = document.createElement('link');
    css.href = SKY_PLAYER_CSS;
    css.rel = 'stylesheet';
    css.onload = resolve;
    css.onerror = reject;
    document.head.appendChild(css);
  });
};

const injectJs = (): Promise<any> => {
  if (document.querySelector(`script[src*="${JS_FILE_NAME}"]`)) {
    return new Promise((resolve) => resolve(true));
  }
  return new Promise((resolve, reject) => {
    const js = document.createElement('script');
    js.src = SKY_PLAYER_JS;
    js.onload = resolve;
    js.onerror = reject;
    document.head.appendChild(js);
  });
};

export const injectScripts = (): Promise<any> => {
  return Promise.all([injectCss(), injectJs()]);
};
